export default {
  choose_subject: "Choisissez une matière",
  show_lesson: "Voir le cours",
  course: "Cours",
  lessonLink: "Lien",
  activityDone: "Activités faites",
  workToDo: "Travail à préparer",
  generalCourses: "Cours généraux",
  attachments: "Pièces jointes",
  attachment: "Pièce jointe",
  download: "Télécharger",
  "Taught subject": "Matière enseignée",
  lesson_info:
    "Ce menu permet de paramétrer des matières en lien avec différents modules : calendrier, compétences, bulletin de notes",
  lesson_search_label: "Rechercher un cours ou une matière",
  lesson_search_placeholder: "Mots-clés : cours, matière...",
  lesson_search_reset: "Effacer la recherche",
  lesson_search_no_result: "Aucun cours ne correspond à votre recherche",
  lessons_count: ({ plural }) => plural(["cours", "cours"]),
  lesson_search_results_count: ({ plural, named }) =>
    plural([`${named("count")} cours trouvé`, `${named("count")} cours trouvés`]),
};
